import React, { useEffect, useState, useCallback } from "react";
import CustomDataGrid from "../ReusableComponent/DataGrid/CustomizeDataGrid";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../Context/LanguageContext";
import Typography from "@mui/material/Typography";
import TabsActions from "../../Actions/TabsActions";
import tabsStore from "../../Stores/TabsStore";
import tabsConstants from "../../Constants/TabsConstants";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { Button, IconButton, Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import { extractFilterOperator } from "../Dashboard/MuiDataGridPro/HelperDashboard";
import ViewChecklist from "./ViewChecklists";
import DetailInspectionView from "./DetailInspectionView";
import { Menu, MenuItem } from "@mui/material";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import { useLocation } from "react-router-dom";
import CommonHeader from "../WebInspection/CommonHeader";
import { ArrowBack } from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
  accountIconButton: {
    padding: 0,
  },
  accountIcon: {
    width: "3rem",
    height: "3rem",
  },
  headerStyle: {
    padding: 8,
  },
}));

export default function InspectionList({
  anlageid,
  handleTourGuid,
  equipmentDetails,
  isUserLogged,
  logoutClick,
  handleBack,
}) {
  const [inspectionList, setInspectionList] = useState([]);
  const [dropDown, setDropDown] = useState(50);
  const [viewChecklist, setViewChecklist] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const [selStatus, setSelStatus] = useState("");
  const [selStatusTranslation, setSelStatusTranslation] = useState("");
  const [openInspectionForm, setOpenInspectionForm] = useState(false);
  const [inspectionId, setInspectionId] = useState("");
  const [inspectionDetails, setInspectionDetails] = useState("");
  const [isAccessingFromPublicWebsite, setIsAccessingFromPublicWebsite] =
    useState(false);
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const location = useLocation();
  const classes = useStyles();

  const columns = [
    (!isAccessingFromPublicWebsite || isUserLogged) && {
      field: "title",
      headerName: localization.checklist,
      hideable: false,
      flex: 1,
    },
    (!isAccessingFromPublicWebsite || isUserLogged) && {
      field: "actions",
      type: "actions",
      hideable: false,
      headerName: localization.actions,
      getActions: (params) => [...getAction(params, localization)],
      maxWidth: 1,
    },
    {
      field: "scheduleAt",
      headerName: localization.scheduleAt,
      hideable: true,
      flex: 1,
    },

    isAccessingFromPublicWebsite &&
      !isUserLogged &&
      equipmentDetails &&
      equipmentDetails.inspectionDisplaySetting != "None" &&
      equipmentDetails.inspectionDisplaySetting != "DatesAndResultOnly" && {
        field: "actions",
        type: "actions",
        hideable: false,
        headerName: localization.actions,
        getActions: (params) => [...getAction(params, localization)],
        maxWidth: 1,
      },

    {
      field: "endDate",
      headerName: localization.pruefdatumLabel,
      hideable: true,
      flex: 1,
    },

    (!isAccessingFromPublicWebsite || isUserLogged) && {
      field: "pruefer",
      headerName: localization.prueferLabel,
      hideable: true,
      flex: 1,
    },
    (!isAccessingFromPublicWebsite || isUserLogged) && {
      field: "turnus",
      headerName: localization.turnusLabel,
      hideable: true,
      flex: 1,
    },
    (!isAccessingFromPublicWebsite || isUserLogged) && {
      field: "frequency",
      headerName: localization.zyklusLabel,
      hideable: true,
      flex: 1,
    },
    {
      field: "nio",
      headerName: localization.inspectionStatus,
      hideable: true,
      flex: 1,
      renderCell: (params) => {
        return renderNio(params.row.nio);
      },
      type: "singleSelect",
      filterOperators: extractFilterOperator("bool", "nio", localization),
      valueOptions: [
        { value: "true", label: localization.nio },
        { value: "false", label: localization.io },
      ],
    },
  ].filter(Boolean);

  function getAction(params) {
    const _acionList = [];
    _acionList.push(
      <GridActionsCellItem
        label={localization.viewDetail}
        showInMenu
        onClick={() => {
          getInspectionDetails(params.row);
        }}
      />,
    );
    return _acionList;
  }

  const getInspectionDetails = (row) => {
    setInspectionDetails({
      checklistTitle: row.title,
      pruefer: row.pruefer,
      frequency: row.frequency,
      endDate: row.endDate,
      nio: row.nio,
      nextCheckDate: row.nextCheckDate,
    });
    setInspectionId(row.id);
    setOpenInspectionForm(true);
  };

  const renderNio = (nioValue) => {
    const backgroundColor = nioValue == "true" ? "#FBE3E3" : "#E3FBE3";
    const textColor = nioValue == "true" ? "#A00" : "#0A470A";

    const nioText = nioValue == "true" ? localization.nio : localization.io;
    return (
      <Tooltip>
        <div
          style={{
            backgroundColor: backgroundColor,
            padding: "0 6px 0 6px",
            display: "flex",
            alignItems: "center",
            borderRadius: "15px",
            color: textColor,
          }}
        >
          <span>{nioText}</span>
        </div>
      </Tooltip>
    );
  };

  const fetchData = useCallback(() => {
    setGlobalSpinner(true);
    if (anlageid !== null && anlageid !== undefined) {
      if (selStatus !== "") {
        TabsActions.getAuftragDetails(anlageid, selStatus, parseInt(dropDown));
      }
    }
  }, [selStatus, dropDown]);

  useEffect(() => {
    fetchData();

    return () => ({});
  }, [fetchData]);

  useEffect(() => {
    //setGlobalSpinner(true);
    if (location.pathname.includes("/public")) {
      setIsAccessingFromPublicWebsite(true);
    }
  }, []);

  useEffect(() => {
    if (isAccessingFromPublicWebsite) {
      TabsActions.getAuftragDetails(
        anlageid,
        "ALL",
        equipmentDetails.inspectionHistoryLimit,
      );
    }

    if (!location.pathname.includes("/public")) {
      TabsActions.getAuftragStatus();
    }
    return () => {};
  }, [isAccessingFromPublicWebsite]);

  useEffect(() => {
    function getInspectionListSuccess() {
      var res = tabsStore.getResult();
      if (res) {
        let temp = res.map((item, index) => {
          item["nio"] = item["nio"] ? "true" : "false";
          return item;
        });
        setInspectionList(temp);
      }
      setGlobalSpinner(false);
    }

    function getInspectionListFailure() {
      var res = tabsStore.getResult();
      setInspectionList([]);
      setGlobalSpinner(false);
    }

    tabsStore.addChangeListener(
      tabsConstants.GET_AUFTRAGSDETAIL_SUCCESS,
      getInspectionListSuccess,
    );

    tabsStore.addChangeListener(
      tabsConstants.GET_AUFTRAGSDETAIL_FAILURE,
      getInspectionListFailure,
    );

    return () => {
      tabsStore.removeChangeListener(
        tabsConstants.GET_AUFTRAGSDETAIL_SUCCESS,
        getInspectionListSuccess,
      );

      tabsStore.removeChangeListener(
        tabsConstants.GET_AUFTRAGSDETAIL_FAILURE,
        getInspectionListFailure,
      );
    };
  }, []);

  useEffect(() => {
    function getOrderStatusSuccess() {
      const res = tabsStore.getOrderStatusResult();
      if (res.length > 0) {
        setStatusList(res);
        setSelStatus(res[2].id);
        setSelStatusTranslation(res[2].text);
      } else {
        setStatusList([]);
      }
      handleTourGuid(2);
      //setGlobalSpinner(false);
    }
    function getOrderStatusFailure() {
      const res = tabsStore.getOrderStatusResult();
      //setGlobalSpinner(false);
    }
    tabsStore.addChangeListener(
      tabsConstants.GET_ORDER_STATUS_SUCCESS,
      getOrderStatusSuccess,
    );
    tabsStore.addChangeListener(
      tabsConstants.GET_ORDER_STATUS_FAILURE,
      getOrderStatusFailure,
    );
    return () => {
      tabsStore.removeChangeListener(
        tabsConstants.GET_ORDER_STATUS_SUCCESS,
        getOrderStatusSuccess,
      );
      tabsStore.removeChangeListener(
        tabsConstants.GET_ORDER_STATUS_FAILURE,
        getOrderStatusFailure,
      );
    };
  }, []);

  function OrderStatusFilter() {
    const [stateAnchorEl, setStateAnchorEl] = React.useState(null);
    const handleStateClick = (event) => {
      setStateAnchorEl(event.currentTarget);
    };

    const handleStateClose = (newState) => {
      if (newState) {
        setSelStatus(newState.id);
        setSelStatusTranslation(newState.text);
      }
      setStateAnchorEl(null);
    };
    return (
      <>
        <Button
          variant="contained"
          className="gridTableButton gridTableButtonStyle"
          style={{ marginLeft: 8 }}
          onClick={handleStateClick}
          endIcon={<UnfoldMoreIcon />}
        >
          {localization.orderStatus + ": " + selStatusTranslation}
        </Button>
        <Menu
          anchorEl={stateAnchorEl}
          open={Boolean(stateAnchorEl)}
          onClose={() => handleStateClose(null)}
        >
          {statusList.map((item, index) => (
            <MenuItem
              key={index}
              style={{ fontSize: "16px" }}
              onClick={() => handleStateClose(item)}
            >
              {item.text}
            </MenuItem>
          ))}
        </Menu>
      </>
    );
  }

  function NumberOfRecordsToViewFilter() {
    const [stateAnchorEl, setStateAnchorEl] = React.useState(null);
    const optionList = [
      { text: 50, value: "50" },
      { text: 100, value: "100" },
      { text: 150, value: "150" },
      { text: 200, value: "200" },
      { text: 250, value: "250" },
    ];
    const handleStateClick = (event) => {
      setStateAnchorEl(event.currentTarget);
    };

    const handleStateClose = (newState) => {
      if (newState) {
        setDropDown(newState.value);
      }
      setStateAnchorEl(null);
    };
    return (
      <>
        <Button
          variant="contained"
          className="gridTableButton gridTableButtonStyle"
          style={{ marginLeft: 8 }}
          onClick={handleStateClick}
          endIcon={<UnfoldMoreIcon />}
        >
          {localization.selectNumberOfRecordToView + ": " + dropDown}
        </Button>
        <Menu
          anchorEl={stateAnchorEl}
          open={Boolean(stateAnchorEl)}
          onClose={() => handleStateClose(null)}
          slotProps={{
            paper: {
              sx: {
                width: 290,
              },
            },
          }}
        >
          {optionList.map((item, index) => (
            <MenuItem
              key={index}
              style={{ fontSize: "16px" }}
              onClick={() => handleStateClose(item)}
            >
              {item.text}
            </MenuItem>
          ))}
        </Menu>
      </>
    );
  }

  return (
    <>
      <div className="container-fluid equipDetailContainer p-5 mt-3">
        {isAccessingFromPublicWebsite && (
          <>
            {isUserLogged ? (
              <div className="row justify-content-end">
                <CommonHeader
                  logoutClick={() => {
                    logoutClick(false);
                  }}
                  classes={classes}
                />
              </div>
            ) : (
              <div className="row justify-content-start">
                <IconButton onClick={handleBack}>
                  <ArrowBack />
                </IconButton>
              </div>
            )}
          </>
        )}

        <div className="row justifyContentSpaceBetw">
          <div className="">
            <Typography gutterBottom variant="h4" component="div">
              {localization.inspectionHistory}
            </Typography>
            {(!isAccessingFromPublicWebsite || isUserLogged) && (
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                {localization.completeInspectionRecord}
              </Typography>
            )}
          </div>
          {!isAccessingFromPublicWebsite && (
            <div>
              <Button
                variant="contained"
                className="containedBtnCls"
                sx={{ textTransform: "none" }}
                startIcon={<AssignmentOutlinedIcon />}
                size="large"
                onClick={() => {
                  setViewChecklist(true);
                }}
              >
                {/* <AssignmentOutlinedIcon sx={{ fontSize: 18 }} className="mr-2" /> */}
                {localization.viewChecklist}
              </Button>
            </div>
          )}
        </div>
        <div className="w-100">
          {inspectionList && (
            <CustomDataGrid
              Title=""
              columns={columns}
              rows={inspectionList}
              operations={""}
              onAdd={""}
              showExport={true}
              showColumns={true}
              showFilters={true}
              showDensity={true}
              visibleColumns={[]}
              showCheckBox={false}
              gridTableHeight={"dataGridLarge"}
              gridFilter={
                !isAccessingFromPublicWebsite ? (
                  <>
                    <OrderStatusFilter /> <NumberOfRecordsToViewFilter />
                  </>
                ) : (
                  <></>
                )
              }
            />
          )}
        </div>
      </div>

      {viewChecklist && (
        <ViewChecklist
          anlageid={anlageid}
          isOpen={viewChecklist}
          setViewChecklist={setViewChecklist}
        />
      )}

      {openInspectionForm && (
        <DetailInspectionView
          open={openInspectionForm}
          onClose={() => setOpenInspectionForm(false)}
          inspectionDetails={inspectionDetails}
          inspectionId={inspectionId}
          equipmentDetails={equipmentDetails}
          isUserLogged={isUserLogged}
        />
      )}
    </>
  );
}
